import { apiClient } from './client';
import { API_ENDPOINTS } from './endpoints';
import { RadiologyTest } from '../types/api.types';

export interface CreateRadiologyTestDto {
  name: string;
  description?: string;
}

export interface UpdateRadiologyTestDto {
  id: number;
  name: string;
  description?: string;
}

export const radiologyTestsApi = {
  getAll: async (): Promise<RadiologyTest[]> => {
    const response = await apiClient.get<RadiologyTest[]>(API_ENDPOINTS.RADIOLOGY_TESTS);
    return response.data;
  },
  create: async (data: CreateRadiologyTestDto): Promise<RadiologyTest> => {
    const response = await apiClient.post<RadiologyTest>(API_ENDPOINTS.RADIOLOGY_TESTS, data);
    return response.data;
  },
  update: async (id: number, data: UpdateRadiologyTestDto): Promise<RadiologyTest> => {
    const response = await apiClient.put<RadiologyTest>(`${API_ENDPOINTS.RADIOLOGY_TESTS}/${id}`, data);
    return response.data;
  },
  remove: async (id: number): Promise<void> => {
    await apiClient.delete(`${API_ENDPOINTS.RADIOLOGY_TESTS}/${id}`);
  },
};

